console.log("Hola desde SLIDERS")
document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.sw-gal-next',
            prevEl: '.sw-gal-prev'
        },
        pagination: {
            el: ".pagination-slider",
            clickable: true,
        },
        on: {
            slideChange: () => {
                forceAutoplay();
            }
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    if(document.querySelector('.slider-cards')){
        let slider_cards_one = new Swiper(".swiper-slider-one", {
            loop: true,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            speed: 500,
            navigation: {
                nextEl: ".sw-gal-prev",
                prevEl: ".sw-gal-next",
            },
            pagination: {
                el: ".pagination-slider",
                clickable: true,
            },
            breakpoints: {
                600: {
                    loop: false,
                    rewind: true,
                    speed: 1000
                }
            }
        });
        
        let slider_cards_two = new Swiper(".swiper-slider-two", {
            loop: true, 
            spaceBetween: 20,
            slidesPerView: 1,
            breakpoints: {
                1024: {
                    slidesPerView: 3
                }
            }
        });


        slider_cards_one.on('slideChange', function () {
            let index = this.realIndex; 
            slider_cards_two.slideToLoop(index); 
        });
        slider_cards_two.on('click', function (event) {
            let clickedSlide = event.clickedIndex;
            if (clickedSlide !== undefined) {
                slider_cards_one.slideToLoop(clickedSlide);
            }
        });
    }

    if(document.querySelectorAll('.card-swiper').length > 0){
        let cards = new Swiper(".card-swiper", {
            speed: 700,
            loop:true,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".sw-gal-next",
                prevEl: ".sw-gal-prev",
            },
            pagination: {
                el: ".pagination-slider",
                clickable: true,
            }
        });
    }
    
    if(document.querySelectorAll('.single-swiper').length > 0){

        let single = new Swiper(".single-swiper", {
            speed: 700,
            loop:true,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".sw-gal-next",
                prevEl: ".sw-gal-prev",
            }
        });
    }

    if(document.querySelectorAll('.rooms__slider').length > 0){
        let rooms = new Swiper(".rooms__slider", {
            speed: 700,
            loop:true,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: ".sw-gal-rooms-next",
                prevEl: ".sw-gal-rooms-prev",
            }
        });
    }

    if(document.querySelector('section.slider')){
        let carousel = new Swiper(".slider__carousel", {
            loop: true,
            speed: 700,
            slidesPerView: 1,  
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },      
            navigation: {
                nextEl: ".sw-gal-next",
                prevEl: ".sw-gal-prev",
            },
            pagination: {
                el: ".pagination-slider",
                clickable: true,
            }
        });

        let carousel_mini = new Swiper(".slider__carousel-mini", {
            loop: true, 
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            }        
        });
        carousel.on('slideChange', function () {
            let index = this.realIndex; 
            carousel_mini.slideToLoop(index); 
        });
        carousel_mini.on('click', function (event) {
            let clickedSlide = event.clickedIndex;
            if (clickedSlide !== undefined) {
                carousel.slideToLoop(clickedSlide);
            }
        });
    }

    
    if(document.querySelectorAll('.slider-columns-swiper').length > 0){

        let slider_columns = new Swiper(".slider-columns-swiper", {
            loop: true, 
            spaceBetween: 20, 
            navigation: {
                nextEl: ".sw-gal-next",
                prevEl: ".sw-gal-prev",
            },
            pagination: {
                el: ".pagination-slider"
            },
            breakpoints: {
                640: { 
                    slidesPerView: 1 
                },
                768: { 
                    slidesPerView: 2 
                },
                1024: { 
                    slidesPerView: 3
                }
            }      
        });
    }

    if(document.querySelectorAll('.slider-history-swiper').length > 0){
        let slider_history = new Swiper(".slider-history-swiper", {
            loop: true, 
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },    
            navigation: {
                nextEl: ".sw-arrow-next",
                prevEl: ".sw-arrow-prev",
            },
            pagination: {
                el: ".pagination-slider",
                clickable: true,
            }
        });
    }
let buttonMenu = document.querySelector("a[href='#TJsMenu']")
if(location.hash=="#TJsMenu"){
    if (buttonMenu){
        buttonMenu.click();
    }
}
console.log('location: '+location.hash);

});
